import React from 'react';
import styles from './AnimatedVisuals.module.css';

const DashboardVisual = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.dashboardHeader}>
        <div className={styles.dashboardIcon}>📊</div>
        <span className={styles.dashboardTitle}>Industry 4.0 Dashboard</span>
      </div>
      <div className={styles.dashboardGrid}>
        <div className={styles.dashboardCard}>
          <div className={styles.metricLabel}>Production</div>
          <div className={styles.metricValue}>98%</div>
          <div className={styles.metricBar}>
            <div className={styles.metricFill} style={{ width: '98%' }}></div>
          </div>
        </div>
        <div className={styles.dashboardCard}>
          <div className={styles.metricLabel}>Efficiency</div>
          <div className={styles.metricValue}>94%</div>
          <div className={styles.metricBar}>
            <div className={styles.metricFill} style={{ width: '94%' }}></div>
          </div>
        </div>
        <div className={styles.dashboardCard}>
          <div className={styles.metricLabel}>Quality</div>
          <div className={styles.metricValue}>99%</div>
          <div className={styles.metricBar}>
            <div className={styles.metricFill} style={{ width: '99%' }}></div>
          </div>
        </div>
        <div className={styles.dashboardCard}>
          <div className={styles.metricLabel}>Uptime</div>
          <div className={styles.metricValue}>100%</div>
          <div className={styles.metricBar}>
            <div className={styles.metricFill} style={{ width: '100%' }}></div>
          </div>
        </div>
      </div>
      <div className={styles.dashboardChart}>
        <div className={styles.chartBar} style={{ height: '60%', animationDelay: '0s' }}></div>
        <div className={styles.chartBar} style={{ height: '80%', animationDelay: '0.1s' }}></div>
        <div className={styles.chartBar} style={{ height: '70%', animationDelay: '0.2s' }}></div>
        <div className={styles.chartBar} style={{ height: '90%', animationDelay: '0.3s' }}></div>
        <div className={styles.chartBar} style={{ height: '85%', animationDelay: '0.4s' }}></div>
        <div className={styles.chartBar} style={{ height: '95%', animationDelay: '0.5s' }}></div>
      </div>
    </div>
  );
};

export default DashboardVisual;

